import React from 'react';
import { connect } from 'react-redux';
import { setModal } from 'ducks/modal';
import DangerButton from 'components/UIKit/Button/DangerButton';
import { Spinner } from 'components/UIKit/Spinner';
import Table, {THead, TBody, Tr, Td, Th } from 'components/UIKit/Table';
import DeleteEntities from 'components/DeleteEntities';
import { TrashIcon } from 'components/icons';
import { DynamicEntityLink } from 'components/Links';

let DependentsError = ({ entities, dependents, processing, dispatch }) => (
  <span>
    <div>{entities[0].errors[0].message}</div>
    <Table style={{border: '1px solid #e5e5e5', marginTop: '1rem'}}>
      <THead>
        <Tr>
          <Th>ID</Th>
          <Th>Entity Type</Th>
        </Tr>
      </THead>
      <TBody>
        {dependents.map(x => {
         const LinkComponent = DynamicEntityLink(x.type, "browse")
         return (
          <Tr key={x.id}>
             <Td>
               <LinkComponent query={{ id: x.id, did: x.id }}>
                 {x.id}
               </LinkComponent>
             </Td>
             <Td style={{ textTransform: 'capitalize' }}>{x.type}</Td>
           </Tr>
          )
        })}
      </TBody>
    </Table>
    <div style={{ margin: '1rem 0' }}>
      Do you want to delete all the entities (including the descendants)
      listed in the report?
    </div>
    <DangerButton
      style={{ width: '10rem' }}
      PrefixComponent={
        processing
          ? <Spinner style={{ width: '15px', height: '15px', marginRight: '0.5rem' }} />
          : <TrashIcon style={{ marginRight: '0.2rem' }} />
      }
      onClick={() => dispatch(setModal({
        Component: () => <DeleteEntities entities={[...dependents, entities[0]]} />,
      }))}
    >
      {processing ? `Processing..` : 'Delete All'}
    </DangerButton>
  </span>
);

export default connect()(DependentsError);
